const RETURN_ROOM_KEY='community_return_room';
const SLUG_PATTERN=/^[a-z0-9]+(?:-[a-z0-9]+)*$/;

function normalizeSlug(value:string|null|undefined){
 try{const slug=decodeURIComponent(String(value||'')).trim().toLowerCase();return SLUG_PATTERN.test(slug)?slug:'';}catch{return '';}
}

function configuredCommunityOrigin(){
 return String(import.meta.env.VITE_PUBLIC_COMMUNITY_ORIGIN||'').trim().replace(/\/+$/,'');
}

export function buildRoomShareUrl(slug:string){
 const safe=normalizeSlug(slug);if(!safe)throw new Error('Ungültiger Raumlink.');
 const canonicalOrigin=configuredCommunityOrigin();
 if(canonicalOrigin)return `${canonicalOrigin}/raum/${encodeURIComponent(safe)}`;
 const base=new URL(import.meta.env.BASE_URL||'/v3/',window.location.origin);
 base.search='';base.hash='';base.searchParams.set('raum',safe);
 return base.toString();
}

export function readRequestedRoomSlug(){
 const query=normalizeSlug(new URLSearchParams(window.location.search).get('raum'));
 const pathMatch=window.location.pathname.match(/(?:^|\/)raum\/([^/?#]+)/i);
 const path=normalizeSlug(pathMatch?.[1]);
 const hashMatch=window.location.hash.match(/(?:^#?\/?)raum\/([^/?#]+)/i);
 const hash=normalizeSlug(hashMatch?.[1]);
 const direct=query||path||hash;
 if(direct){localStorage.setItem(RETURN_ROOM_KEY,direct);return direct;}
 return normalizeSlug(localStorage.getItem(RETURN_ROOM_KEY));
}

export function clearRequestedRoom(){localStorage.removeItem(RETURN_ROOM_KEY);}

export function communityHomeUrl(){
 const canonicalOrigin=configuredCommunityOrigin();
 return canonicalOrigin?`${canonicalOrigin}/`:new URL(import.meta.env.BASE_URL||'/v3/',window.location.origin).toString();
}
